import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { SapError } from 'src/app/lego-utils';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { Subscription } from 'rxjs';
import { CharacteristicDataService } from 'src/app/services';

export interface CharacteristicLongTextDialogData {
  client: string;
  plant: string;
  masterInspectionCharacteristics: string;
  mkVersion: string;
}

@Component({
  selector: 'em-characteristic-long-text-dialog',
  templateUrl: './characteristic-long-text-dialog.component.html',
  standalone: false,
})
export class CharacteristicLongTextDialogComponent implements OnInit, OnDestroy {
  public isLoading = true;
  public errorMessage?: string;
  public longText?: string;

  private readonly subscriptions = new Subscription();

  public constructor(
    private readonly characteristicDataService: CharacteristicDataService,
    @Inject(NZ_MODAL_DATA) private readonly data: CharacteristicLongTextDialogData
  ) {}

  public ngOnInit(): void {
    const { client, plant, masterInspectionCharacteristics, mkVersion } = this.data;

    this.subscriptions.add(
      this.characteristicDataService
        .getLongText(client, plant, masterInspectionCharacteristics, mkVersion)
        .subscribe({
          error: (error: SapError) => {
            this.errorMessage = error.toString();
            this.isLoading = false;
          },
          next: (longText) => {
            this.longText = longText;
            this.isLoading = false;
          },
        })
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
